import { useMutation, useQueryClient } from 'react-query';
import {
  claimBettieDailyCheckInReward,
  type ClaimBettieDailyCheckInRewardResponse
} from '../../services/bettieService';

export function useClaimBettieDailyCheckInReward() {
  const queryClient = useQueryClient();
  return useMutation<ClaimBettieDailyCheckInRewardResponse, Error>(
    () => claimBettieDailyCheckInReward(),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['bettieDailyCheckInStatus']);
        queryClient.invalidateQueries(['bettieBalances']);
      }
    }
  );
}
